module.exports = __webpack_public_path__ + "assets/images/vcr_officeBuilding-02.80f4a272194da3e5b3b6daf0b8b4154d.svg";